var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.25,
    y: 6.25,
    width: 11.5,
    height: 19.5,
    rx: 0.75,
    fill: "#F0EFEB",
    stroke: "#DFDFDF",
    strokeWidth: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 17.6992,
    width: 8,
    height: 1,
    fill: "#B1AFA6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 7.82089,
    width: 8,
    height: 8.36327,
    fill: "#6C695B"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 19.5498,
    width: 8,
    height: 1,
    fill: "#B1AFA6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 21.4502,
    width: 8,
    height: 1,
    fill: "#B1AFA6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 23.3008,
    width: 8,
    height: 1,
    fill: "#B1AFA6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.792 2.18394C17.792 2.18394 17.79 3.54946 16.3638 4.39276C14.9376 5.23606 12.6273 5.23779 12.6273 5.23779C12.6273 5.23779 12.9376 3.73606 14.3638 2.89276C15.79 2.04946 17.792 2.18394 17.792 2.18394Z",
    fill: "#11D511",
    stroke: "#08BA08",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a4d294dd75b96406e345aa5328f5e4f7.svg";
export { ForwardRef as ReactComponent };